import { post } from "../api"
import { REPORT_BY_ID } from "./urls"

const getReport = (filters, reportId, token = "") => {
  const formattedFilters = {
    ...filters,
    factories: filters?.factories?.map(v => v.value),
    product: filters?.product?.map(v => v.value),
    uf: filters?.uf?.map(v => v.value),
    courrier: filters?.courrier?.map(v => v.value),
  }
  const endpoint = REPORT_BY_ID.replace(":id", reportId)
  return post(
    endpoint,
    {
      filters: formattedFilters,
    },
    {
      cancelToken: token,
    }
  )
}

export { getReport }
